// src/components/ConfirmDialog.jsx
import React from "react";

export default function ConfirmDialog({
  open,
  title = "Bevestigen",
  message,
  confirmLabel = "Ja",
  cancelLabel = "Nee",
  busy = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/40 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg p-5 max-w-sm w-[90%]">
        <h3 className="text-lg font-bold mb-2">{title}</h3>
        <p className="text-sm text-gray-800 mb-4 whitespace-pre-line">
          {message}
        </p>
        <div className="flex justify-end gap-2">
          <button
            className="px-3 py-1 rounded border border-gray-300 bg-gray-100 text-sm"
            onClick={onCancel}
            disabled={busy}
          >
            {cancelLabel}
          </button>
          <button
            className="px-3 py-1 rounded bg-red-600 text-white text-sm"
            onClick={onConfirm}
            disabled={busy}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
